import { lazy } from "react";

export const Main = lazy(() => import("../pages/Main/Main"));

export const MapBrowser = lazy(() => import("../pages/MapBrowser/MapBrowser"));

export const FAQ = lazy(() => import("../pages/FAQ/FAQ"));

export const About = lazy(() => import("../pages/About/About"));

export const Create = lazy(() => import("../pages/Create/Create"));

export const ServicePageStandalone = lazy(
  () => import("../pages/Service/ServicePageStandalone"),
);
